export default __webpack_public_path__ + "static/media/zapsplat_leisure_playing_cards_several_set_down_001_65941.f77cb265.mp3";